export default __webpack_public_path__ + "static/media/breadhound-1.ea875d4b.png";